import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-869f69fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "el-card",
  style: {"padding":"0 20px 20px","height":"100%","box-sizing":"border-box","background-color":"var(--cm-color-card-bg)"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { style: {"height":"calc(100% - 30px)","padding":"18px 0","box-sizing":"border-box","display":"flex","flex-direction":"column","justify-content":"space-between"} }

import CmForm from '@/components/cmForm/index.vue'
import CmTable from '@/components/cmTable/index.vue'
import { DateType, FormActionType, FormSize, FormType, ObjectFormItem } from '@/components/cmForm/types';
import { reactive, ref, watch, computed } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh';
import { useParseTime } from '@/hooks';
import { useReflectiveInjector } from '@tanbo/vue-di-plugin';
import { CascadeService, CascadeAppliesData } from './service';
import { ApplyState, ApprovalStateLabel, ApproveQueryForm, ExcludeRequestParamsApprove, PermissionsState, State } from './types';
import { formatMapToOptions } from '@/utils/tool';
import { useI18n } from 'vue-i18n';
import { ElMessageBox, ElMessage } from 'element-plus';
import { formatTimeStamp } from '@/utils/time';
import { TableOpt, TableActOpt } from '@/components/cmTable/types';
const hasPermission = true

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n()

function approvalStateName(value: string): string {
  const map: Record<string, string> = {
    [ApplyState.Preview]: 'cascadeApproval.statePending',
    [ApplyState.Allowed]: 'cascadeApproval.stateAllowed',
    [ApplyState.Rejected]: 'cascadeApproval.stateRejected',
    [ApplyState.Disconnect]: 'cascadeApproval.stateExpired',
  }
  const key = map[value]
  return key ? t(key) : ''
}

function permissionLabel(key: string): string {
  const map: Record<string, string> = {
    [PermissionsState.Password_free_login]: 'cascadeApproval.permPasswordFree',
    [PermissionsState.Get_upgrade]: 'cascadeApproval.permGetUpgrade',
    [PermissionsState.Get_patch]: 'cascadeApproval.permGetPatch',
    [PermissionsState.Sync_log]: 'cascadeApproval.permSyncLog',
    [PermissionsState.Get_virus]: 'cascadeApproval.permGetVirus',
  }
  const i18nKey = map[key]
  return i18nKey ? t(i18nKey) : key
}

function formatPermissions(_row: CascadeAppliesData, val: string[] = []) {
  return val.length ? val.map((v) => permissionLabel(v)).join(',') : '--'
}

const injector = useReflectiveInjector([CascadeService])
const cascadeService = injector.get(CascadeService)
const getCascadeApplyListApi = cascadeService.getCascadeApplyList.bind(cascadeService)
const ApproveApi = cascadeService.getCascadeApprove.bind(cascadeService)
const activeName = ref('first')
const disabled = ref(!hasPermission)
const form = reactive<ApproveQueryForm>({ status: ApplyState.Preview })
const send_file_approval_count = ref(0)
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const formColumns = computed<ObjectFormItem<ApproveQueryForm, ExcludeRequestParamsApprove>>(() => {
  void locale.value
  return {
    status: {
      hidden: () => activeName.value === 'first',
      colOpt: { style: 'width: 110px;flex:0 0 auto' },
      hiddenAllLabel: true,
      type: FormType.Select,
      selectOpt: {
        clearable: true,
      },
      placeholder: t('cascadeApproval.approveStatusPh'),
      events: {
        change: () => void refreshList(),
      },
      dictData: formatMapToOptions(ApprovalStateLabel).filter(item => item.value !== ApplyState.Preview).map((item) => ({
        ...item,
        label: approvalStateName(String(item.value)),
      })),
    },
    date: {
      colOpt: { style: 'flex:0 0 260px' },
      hiddenAllLabel: true,
      type: FormType.Date,
      dateType: DateType.DateRange,
      events: {
        change: (val) => {
          const [start, end] = useParseTime(val);
          form.start_time = start;
          form.end_time = end;
          void refreshList()
        },
      },
      dateOpt: {
        'value-format': 'YYYY-MM-DD',
        'start-placeholder': t('remoteAuth.startPlaceholder'),
        'end-placeholder': t('remoteAuth.endPlaceholder'),
        clearable: true,
      },
    },
    keyword: {
      colOpt: { style: 'flex: 0 0 370px' },
      hiddenAllLabel: true,
      placeholder: t('cascadeApproval.searchPlaceholder'),
      modelModifiers: { trim: true },
      inputOpt: {
        'suffix-icon': 'el-icon-search',
      },
      events: {
        blur: () => void refreshList(),
        keypress: (e) => e.charCode === 13 && void refreshList()
      },
    },
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  const baseCols = [
    { label: t('cascadeApproval.applyTime'), width: 150, prop: 'apply_time', formatter: (_row: CascadeAppliesData, val: string) => formatTimeStamp(val, 'YYYY-MM-DD HH:mm') },
    { label: t('cascadeApproval.childName'), width: 200, prop: 'child_team_name', },
    { label: t('cascadeApproval.ipAddress'), width: 200, prop: 'child_server_host', },
    { label: t('cascadeApproval.port'), prop: 'child_server_port', width: 120 },
    { label: t('cascadeApproval.permissionConfig'), prop: 'permissions', formatter: formatPermissions },
  ]
  const reasonItem = { label: t('cascadeApproval.reason'), prop: 'approve_reason', width: 150 }
  const approve_time = { label: t('cascadeApproval.approveTime'), width: 150, prop: 'approve_time', formatter: (_row: CascadeAppliesData, val: string) => val === '0' ? '--' : formatTimeStamp(val, 'YYYY-MM-DD HH:mm') }
  const statueItem = { label: t('cascadeApproval.auditStatus'), prop: 'status', width: 150 }
  const columns = activeName.value === 'first'
    ? [...baseCols]
    : [statueItem, approve_time, ...baseCols, reasonItem]
  return {
    bodyStyle: 'padding: 0',
    showActionBar: false,
    showForm: true,
    showRightToolbar: false,
    height: '100%',
    showTip: false,
    rowKey: 'id',
    selection: false,
    path: 'applies',
    columns
  }
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    isLink: true,
    height: '100%',
    columnOpt: { label: t('cascadeApproval.operation'), width: 150, align: 'left' },
    actionButtons: () => [{ name: t('cascadeApproval.agree'), type: 'confirm', opt: { size: 'small', icon: '', type: 'primary', } },
    { name: t('cascadeApproval.reject'), type: 'reject', opt: { size: 'small', icon: '', type: 'danger', } },]
  }
})
watch(() => activeName.value, () => {
  form.status = activeName.value === 'first' ? ApplyState.Preview : ''
  void refreshList()
})
const handleAction = ({ type, rowItem: row }) => {
  const types = {
    confirm: async () => {
      await ElMessageBox.confirm(t('cascadeApproval.confirmAgree'), t('genuineSoftwareCm.tip'), { confirmButtonText: t('common.confirm'), cancelButtonText: t('common.cancel'), })
      await ApproveApi({ apply_id: row.id, approved: true })
      ElMessage({ type: 'success', message: t('cascadeApproval.opSuccess'), })
      void refreshList()
    },
    reject: async () => {
      const { value } = await ElMessageBox.prompt(t('cascadeApproval.rejectReason'), t('genuineSoftwareCm.tip'), { confirmButtonText: t('common.confirm'), customClass: 'custom-input', cancelButtonText: t('common.cancel'), inputPlaceholder: t('cascadeApproval.rejectReasonPlaceholder'), inputSize: 'small' })
      await ApproveApi({ apply_id: row.id, approved: false, reason: value })
      void refreshList()
      ElMessage({
        type: 'success',
        message: t('cascadeApproval.opSuccess'),
      })
    },
  }
  types[type]?.()
}


return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      class: "demo-tabs",
      style: {"padding-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          name: "first",
          disabled: !hasPermission,
          style: {"position":"relative"}
        }, {
          label: _withCtx(() => [
            (send_file_approval_count.value)
              ? (_openBlock(), _createBlock(_component_el_badge, {
                  key: 0,
                  value: send_file_approval_count.value,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('cascadeApproval.pending')), 1)
                  ]),
                  _: 1
                }, 8, ["value"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('cascadeApproval.pending')), 1))
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('cascadeApproval.approved'),
          name: "second",
          disabled: !hasPermission
        }, null, 8, ["label", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CmTable, {
        tableOpt: tableOpt.value,
        api: _unref(getCascadeApplyListApi),
        "has-permission": true,
        cardOpt: { style: { height: '100%', border: 'none' } },
        ref_key: "tableRef",
        ref: tableRef,
        pageOption: { pageNumName: 'page', pageSizeName: 'limit' },
        tableActOpt: activeName.value === 'first' && tableActOpt.value,
        modelValue: form,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form) = $event)),
        onHandleAction: handleAction,
        firstLoading: true
      }, {
        header: _withCtx(() => [
          _createVNode(CmForm, {
            modelValue: form,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form) = $event)),
            rowOpt: { style: 'justify-content:flex-end' },
            disabled: disabled.value,
            "onUpdate:disabled": _cache[2] || (_cache[2] = ($event: any) => ((disabled).value = $event)),
            formSize: _unref(FormSize).Small,
            formColumns: formColumns.value,
            formType: _unref(FormActionType).Other,
            "onUpdate:formType": _cache[3] || (_cache[3] = ($event: any) => ((_unref(FormActionType).Other) = $event))
          }, null, 8, ["modelValue", "disabled", "formSize", "formColumns", "formType"])
        ]),
        status: _withCtx(({ value }) => [
          _createVNode(_component_el_tag, {
            size: "small",
            type: _unref(State)[String(value)]?.type
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(State)[String(value)]?.icon)
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(approvalStateName(String(value))), 1)
            ]),
            _: 2
          }, 1032, ["type"])
        ]),
        _: 1
      }, 8, ["tableOpt", "api", "tableActOpt", "modelValue"])
    ])
  ]))
}
}

})